export default __webpack_public_path__ + "static/sur-mesure-34c215179d3c2c1a3bd736559bbbd405.png";